import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { Icon } from '@swf/sports/components';
import type { Props as DefaultEventStatusProps } from '@swf/sports/components/EventStatus/components/DefaultEventStatus/DefaultEventStatus';
import type { EventTypeId } from '@swf/sports/types/eventType';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

import { TXTWCL_In_Play } from './BadgeWithEventStatus.messages.json';
import styles from './BadgeWithEventStatus.scss';

interface MarketNameProps extends DefaultEventStatusProps {
  eventTypeId: EventTypeId;
  marketName: string;
  badge?: never;
}

interface BadgeProps extends DefaultEventStatusProps {
  eventTypeId?: never;
  marketName?: never;
  badge: React.ReactElement;
}

const BadgeWithEventStatus: React.FC<MarketNameProps | BadgeProps> = (props) => (
  <div className={styles.container}>
    {'badge' in props ? (
      props.badge
    ) : (
      <div className={styles.marketNameContainer}>
        <Icon name={getEventTypeIcon(props.eventTypeId)} size="lg" />
        <span>{props.marketName}</span>
      </div>
    )}
    {props.inPlay && (
      <div className={styles.eventStatusContainer}>
        <Translation {...TXTWCL_In_Play} />
        <Icon name={'in-play'} size="xl" />
      </div>
    )}
  </div>
);

export default BadgeWithEventStatus;
